<template>
  <div class="dashboard__view mandates">
    <div class="page">
      <div class="page__title"></div>
    </div>
    <div class="list">
      <div class="tab__content">
        <div class="tab__content__top">
          <div class="tab__content__top__left">
            {{ pageInfo.total }} Mandates
          </div>
          <div class="tab__content__top__right">
            <div class="tab__content__top__item">
              <button
                @click="clearFilter"
                class="btn btn--sm btn--text"
                v-if="openFilters"
              >
                Clear Filter
              </button>
            </div>
            <div class="tab__content__top__item">
              <button
                @click="openFilters = true"
                class="btn btn--sm btn--default"
              >
                Filter
              </button>
            </div>
            <div class="tab__content__top__item">
              <div v-if="mandateList.length > 0" class="show-export">
                <Button
                  buttonName="Export"
                  :disabled="exportDisabled"
                  :onClick="
                    () => (this.showExportOptions = !this.showExportOptions)
                  "
                  classes="basic"
                >
                  <span>
                    <svg
                      fill="none"
                      height="12"
                      viewBox="0 0 14 18"
                      width="14"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.25 0V12.4219L2.28906 8.46094L1.21094 9.53906L6.46094 14.7891L7 15.3047L7.53906 14.7891L12.7891 9.53906L11.7109 8.46094L7.75 12.4219V0H6.25ZM0.25 16.5V18H13.75V16.5H0.25Z"
                        fill="#e00b5b"
                      />
                    </svg>
                  </span>
                </Button>
                <div class="export-options" v-if="this.showExportOptions">
                  <div
                    class="export-options__option"
                    @click="
                      () => {
                        this.showExportOptions = false;
                        this.exportData('pdf');
                      }
                    "
                  >
                    PDF
                  </div>
                  <div
                    class="export-options__option"
                    @click="
                      () => {
                        this.showExportOptions = false;
                        this.exportData('csv');
                      }
                    "
                  >
                    CSV
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="tab__content__top"
          style="padding-top: 0"
          v-if="openFilters"
        >
          <div class="tab__content__top__left">.</div>
          <div class="tab__content__top__right">
            <form @submit.prevent="triggerFilter">
              <div class="filter">
                <div class="form__item">
                  <div class="form__label account-number">Account Number</div>
                  <input
                    @keydown="preventKeys"
                    class="form__input"
                    maxlength="10"
                    type="text"
                    v-model="filterList.account_number"
                  />
                </div>
                <div class="form__item">
                  <div class="form__label">Amount(NGN)</div>
                  <input
                    @keydown="preventKeys"
                    class="form__input"
                    maxlength="10"
                    type="text"
                    v-model="filterList.amount"
                  />
                </div>
                <div class="form__item">
                  <div class="form__label">Start Date</div>
                  <datepicker
                    class="form__input"
                    v-model="filterList.start_date"
                  />
                </div>
                <div class="form__item">
                  <div class="form__label">End Date</div>

                  <datepicker
                    class="form__input jjj"
                    v-model="filterList.end_date"
                    bootstrap-styling
                    id="input"
                    :input-class="{ width: '100px' }"
                  />
                </div>
                <div class="form__item">
                  <div class="form__label">Frequency</div>
                  <div class="select">
                    <select
                      class="select__input select__input--sm"
                      v-model="filterList.frequency"
                    >
                      <option value="INSTANT">INSTANT</option>
                      <option value="DAILY">DAILY</option>
                      <option value="WEEKLY">WEEKLY</option>
                      <option value="MONTHLY">MONTHLY</option>
                    </select>
                    <div class="select__icon select__icon--sm">
                      <svg
                        height="10"
                        viewBox="0 0 6 10"
                        width="6"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"
                          fill="#637381"
                          fill-rule="evenodd"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                <div class="form__item">
                  <div class="form__label">Status</div>
                  <div class="select">
                    <select
                      class="select__input select__input--sm"
                      v-model="filterList.status"
                    >
                      <option value="active">Active</option>
                      <option value="pending_customer_approval">Pending</option>
                      <option value="cancelled">Cancelled</option>
                    </select>
                    <div class="select__icon select__icon--sm">
                      <svg
                        height="10"
                        viewBox="0 0 6 10"
                        width="6"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"
                          fill="#637381"
                          fill-rule="evenodd"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="form__item">
                  <div class="form__label">Execution Time</div>
                  <datepicker
                    class="form__input"
                    v-model="filterList.createdAt"
                  />
                </div>

                <div class="form__item" style="padding-top: 33px">
                  <button
                    :disabled="disabled"
                    class="btn btn--primary btn--filter"
                    type="submit"
                  >
                    Apply Filter
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div> 
        <EmptyState v-if="emptyState" type="not-found" icon="mandate" />

        <div v-else>
          <!-- Loader -->
          <div class="loader" v-if="loading">
            <span aria-hidden="true" class="spinner-border"></span>
          </div>
          <table class="table card-table" v-else>
            <thead>
              <tr>
                <!-- <th>REFERENCE</th> -->
                <th></th>
                <th>Customer Name</th>
                <th>Bank</th>
                <th>Account Number</th>
                <th>Amount</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Frequency</th>
                <th>Execution Time</th>
              </tr>
            </thead>
            <tbody>
              <router-link
                :key="item.unique_reference"
                :to="{
                  name: 'mandate-details',
                  params: { id: item.mandate_reference },
                }"
                tag="tr"
                v-for="item in mandateList"
              >
                <!-- <td style="max-width: 140px !important; word-break: break-all;">
                                    <span class="name">{{item.unique_reference}}</span>
                                </td>-->
                <td style="max-width: 20px">
                  <StatusIndicator :type="item.status" />
                </td>
                <td>{{ item.customer_name }}</td>
                <td class="uppercase">
                  {{ findBank(item.bank_code) }}
                </td>
                <td>{{ item.account_number }}</td>
                <td>₦{{ item.amount | money }}</td>
                <td>{{ item.start_date | date }}</td>
                <td>{{ item.end_date | date }}</td>
                <td>{{ item.frequency }}</td>
                <td>
                  <span>{{ item.createdAt | date }}</span>
                </td>
                <!-- <td>
                                    <span class="tag active" v-if="item.status == 'ACTIVE'">Successful</span>
                                    <span class="tag pending" v-else-if="item.status == 'INQ'">Pending</span>
                                    <span class="tag inactive" v-else>Failed</span>
                                </td> -->
              </router-link>
            </tbody>
          </table>
          <div
            class="table__details"
            v-if="loading !== true && emptyState !== true"
          >
            <div class="table__details__left">
              <span class="text-muted" v-if="pageInfo.total"
                >Page {{ pageInfo.current_page }} of
                {{ pageInfo.total_pages }}</span
              >
            </div>
            <div class="table__details__right">
               <Pagination :numberOfPages="pageInfo.total_pages" />
            </div>
            <div class="table__details__right"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import emptyTransactions from "../../../components/emptytransactions";
import Button from "@/components/button.vue";
import Pagination from "@/components/pagination.vue";
import StatusIndicator from "@/components/status-indicator.vue";
import EmptyState from "@/components/empty-state.vue";

export default {
  metaInfo: {
    title: "Direct Debit Mandates",
  },
  data() {
    return {
      mandateList: "",
      pageInfo: "",
      filterList: {
        account_number: this.$route.query.account_number
          ? this.$route.query.account_number
          : "",
        start_date: this.$route.query.start_date
          ? this.$route.query.start_date
          : "",
        status: this.$route.query.status ? this.$route.query.status : "",
        end_date: this.$route.query.end_date ? this.$route.query.end_date : "",
        frequency: this.$route.query.frequency
          ? this.$route.query.frequency
          : "",
        createdAt: this.$route.query.createdAt
          ? this.$route.query.createdAt
          : "",
        amount: this.$route.query.amount ? this.$route.query.amount : "",
      },
      disabled: false,
      polling: "",
      exportDisabled: false,
      loading: true,
      emptyState: false,
      openFilters: false,
      showExportOptions: false,
    };
  },

  created() {
    this.fetchMandates();
  },

  components: {
    Datepicker,
    emptyTransactions,
    Button,
    Pagination, 
    StatusIndicator, EmptyState
  },

  watch: {
    // call again the fetch method if the route changes; this is necessary especially because of users
    // using the search and might be on this route already.
    $route: "fetchMandates",
  },

  computed: {
    bankNames() {
      return this.$store.state.bankNames;
    },

    userPermissions() {
      return this.$store.getters.getUserPermission;
    },
  },

  methods: {
    findBank(cbnCode) {
      if (this.bankNames) {
        const bank = Object.values(this.bankNames).find(
          (bank) => bank.cbn_code == cbnCode
        );
        return bank ? bank.name : "";
      }
    },
    returnQuery() {
      let queryParams = Object.entries(this.$route.query);
      let generatedQuery = "";
      let i = 0;
      // Loop through arrays and generate the query string
      for (let [name, value] of queryParams) {
        generatedQuery += `${name}=${value}`;
        i++;
        if (i < queryParams.length) {
          generatedQuery += "&";
        }
      }

      return generatedQuery;
    },
    generatePaginationLink(pageNum) {
      return {
        path: "/dashboard/mandates",
        query: {
          ...this.$route.query,
          page: pageNum,
        },
      };
    },
    triggerFilter() {
      let queryObject = {};
      if (
        this.filterList.account_number !== undefined &&
        String(this.filterList.account_number).trim() !== ""
      ) {
        queryObject.account_number = String(
          this.filterList.account_number
        ).trim();
      }
      if (
        this.filterList.status !== undefined &&
        String(this.filterList.status).trim() !== ""
      ) {
        queryObject.status = this.filterList.status;
      }
      if (
        this.filterList.start_date !== undefined &&
        this.filterList.start_date !== ""
      ) {
        queryObject.start_date = moment(this.filterList.start_date).format(
          "YYYY-MM-DD"
        );
      }
      if (
        this.filterList.end_date !== undefined &&
        this.filterList.end_date !== ""
      ) {
        queryObject.end_date = moment(this.filterList.end_date).format(
          "YYYY-MM-DD"
        );
      }
      if (
        this.filterList.frequency !== undefined &&
        String(this.filterList.frequency).trim() !== ""
      ) {
        queryObject.frequency = String(this.filterList.frequency).trim();
      }
      if (
        this.filterList.createdAt !== undefined &&
        String(this.filterList.createdAt).trim() !== ""
      ) {
        queryObject.createdAt = moment(this.filterList.createdAt).format(
          "YYYY-MM-DD"
        );
      }
      if (
        this.filterList.amount !== undefined &&
        String(this.filterList.amount).trim() !== ""
      ) {
        queryObject.amount = String(this.filterList.amount).trim();
      }

      queryObject.page = 1;

      //Route to page with query
      this.$router.push({ path: "/dashboard/mandates", query: queryObject });
    },
    clearFilter() {
      this.filterList = {
        account_number: "",
        end_date: "",
        start_date: "",
        status: "",
        frequency: "",
        createdAt: "",
        amount: "",
      };
      this.openFilters = false;
      this.$router.push({ path: "/dashboard/mandates?page=1" });
    },
    fetchMandates() {
      // Convert object to multiple arrays with name and value
      let generatedQuery = this.returnQuery();

      this.$http
        .get(
          `${process.env.VUE_APP_DD_API_URL}/admin/mandates?${generatedQuery}`
        )
        .then((response) => {
          const { body } = response.data;
          // console.log(response.data.body,"<<< RESPONSE");
          if (body.rows.length > 0) {
            this.mandateList = body.rows;
            this.pageInfo = {
              total: body.total_items,
              current_page: body.current_page_number,
              total_pages: body.total_pages,
            };
            this.emptyState = false;
            this.loading = false;
          } else {
            this.mandateList = body.rows;
            this.pageInfo = {
              total: body.total_items,
              current_page: body.current_page_number,
              total_pages: body.total_pages,
            };
            this.emptyState = true;
            this.loading = false;
          }
        })
        .catch((error) => {
          // LOG Error
          // console.log(error);
          this.emptyState = true;
          this.loading = false;
        });
    },
    exportData(type) {
      this.$store.dispatch("downloadDirectDebitMandateList", {
        downloadType: type,
        filter: { download: "true", download_size: '1000000', ...this.filterList },
      });
    },
    formatDate(date) {
      return moment(date).format("LLL");
    },
  },
};
</script>

<style lang="scss" scoped>
.mandates {
  select,
  input,
  .vdp-datepicker {
    width: 120px !important;
  }

  .form__input {
    > div {
      overflow: scroll;
    }
  }

  .account-number {
    width: 110px;
  }
}

.show-export {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;

  .export-options {
    background: #fff;
    z-index: 100;
    padding: 10px;
    box-shadow: 0 0 0 0 0.05;
    position: absolute;
    bottom: -85px;
    width: 93px;
    right: 0;
    border: 1px solid #dfe2e5;
    border-radius: 4px;

    &__option {
      padding: 8px 0;
      color: #e00b5b;
      font-size: 12px;
      cursor: pointer;
    }
  }
}
</style>
